module.exports = __webpack_public_path__ + "static/media/eclipse.bdf33fe6.png";